import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function Postprocessing(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Postprocessing</h2>
                <li>
                    <Link to={`${url}/plating`}>Plating</Link>
                </li>
                <li>
                    <Link to={`${url}/polishing`}>Polishing</Link>
                </li>
                <li>
                    <Link to={`${url}/abrasiveblasting`}>Abrasive Blasting</Link>
                </li>
                <li>
                    <Link to={`${url}/corrosion`}> Anodizing & Corrosion</Link>
                </li>
                <li>
                    <Link to={`${url}/coldforming`}>Cold Forming</Link>
                </li>
                <li>
                    <Link to={`${url}/vibratory`}>Vibratory Finish</Link>
                </li>    
                <li>
                    <Link to={`${url}/lubricants`}>Lubricants</Link>
                </li>    
                <li>
                    <Link to={`${url}/workhardening`}>Work Hardening</Link>
                </li>      
                <li>
                    <Link to={`${url}/screenprinting`}>Screen Printing</Link>
                </li>  
                  <li>
                    <Link to={`${url}/sanding`}>Sanding</Link>
                </li>    
                <li>
                    <Link to={`${url}/woodfinishes`}>Wood Finishes</Link>
                </li>       
                  <li>
                    <Link to={`${url}/laserengraving`}>Laser Engraving</Link>
                </li>  
                    <li>
                    <Link to={`${url}/resinprintingfinishing`}>Resin Printing Finishing</Link>
                </li> 
                    <li>
                    <Link to={`${url}/metrology`}>Metrology</Link>
                </li>  
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Postprocessing; 